export default __webpack_public_path__ + "static/media/cardImage.3d4ac35c.jpg";